import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccordionComponent } from './accordion.component';
import { AccordionTabComponent } from './accordion-tab/accordion-tab.component';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionTabComponent
  ],
  imports: [
    CommonModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    AccordionComponent,
    AccordionTabComponent
  ]

})
export class AccordionModule { }
